module.exports = __webpack_public_path__ + "static/ezs-a384e197a3ce1eb8b5092400b2008406.jpg";